var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{style:({top: '64px'}),attrs:{"color":"primary","value":_vm.navbarShow,"width":"289","absolute":""},on:{"input":_vm.stateNavbarShow}},[_c('div',{staticClass:"left-notch"},[_c('the-layout-drawer-list',{attrs:{"dense":_vm.navbarDense,"routes":_vm.permissionRoutes,"icon-show":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }